import { useMemo, useState } from "react";
import { Row, Col, Input, Select, Button, Space, Tooltip, Modal, message, } from "antd";
import { ClearOutlined, EnvironmentOutlined, FileSearchOutlined, ProjectOutlined, ShopOutlined, SyncOutlined, } from "@ant-design/icons";
import ExportarExcelDropdown from "./ExportarExcelDropdown";
import { ejecutarSyncSoportes } from "../../../../services/financiero/syncSoportesService";

const { Option } = Select;

export default function EntregasFilters({
  filters,
  setFilters,
  departamentos = [],
  municipios = [],
  proyectos = [],
  userLogin,
}) {
  const [loadingSync, setLoadingSync] = useState(false);
  const puedeSincronizar = userLogin === "admin" || userLogin === "brayan";
  const handleChange = (field, value) => {
    if (field === "departamento") {
      setFilters((prev) => ({
        ...prev,
        departamento: value,
        municipio: null,
      }));
      return;
    }

    setFilters((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const municipiosFiltrados = useMemo(() => {
    if (!filters.departamento) return [];
    return municipios.filter(
      (m) => Number(m.oid_depto) === Number(filters.departamento)
    );
  }, [municipios, filters.departamento]);

  const clearFilters = () => {
    setFilters({
      search: "",
      archivo: "",
      proyecto: [],
      departamento: null,
      municipio: null,
      producto: null,
      tipo_entrega: null,
    });
  };

  const handleSync = async () => {
    try {
      setLoadingSync(true);

      const user = localStorage.getItem("user") || "admin";

      message.loading({
        content: "Iniciando sincronización...",
        key: "sync",
      });

      const res = await ejecutarSyncSoportes(user);

      message.success({
        content: res.message || "Proceso iniciado correctamente",
        key: "sync",
      });

    } catch (error) {
      console.error(error);

      message.error({
        content: "Error al sincronizar soportes",
        key: "sync",
      });

    } finally {
      setLoadingSync(false);
    }
  };

  const confirmSync = () => {
    Modal.confirm({
      title: "¿Sincronizar soportes?",
      content: "Esto ejecutará el proceso en base de datos",
      okText: "Sí, sincronizar",
      cancelText: "Cancelar",
      onOk: handleSync,
    });
  };

  return (
    <div>
      <Row gutter={[12, 12]} align="middle">
        <Col xs={24} md={12} lg={8}>
          <Tooltip title="Buscar por producto, identificación o nombre">
            <Input
              allowClear
              placeholder="Buscar por producto, identificación o nombre"
              value={filters.search}
              onChange={(e) => handleChange("search", e.target.value)}
            />
          </Tooltip>
        </Col>
        <Col xs={24} md={12} lg={8}>
          <Tooltip title="Buscar por nombre del archivo de soporte">
            <Input
              allowClear
              placeholder="Buscar por archivo"
              value={filters.archivo}
              prefix={<FileSearchOutlined style={{ color: "rgba(0, 0, 0, 0.25)" }} />}
              onChange={(e) => handleChange("archivo", e.target.value)}
            />
          </Tooltip>
        </Col>
        <Col xs={24} md={12} lg={8}>
          <Select
            mode="multiple"
            allowClear
            showSearch
            placeholder="Proyecto"
            optionFilterProp="children"
            style={{ width: "100%" }}
            value={filters.proyecto}
            suffixIcon={<ProjectOutlined />}
            onChange={(v) => handleChange("proyecto", v)}
          >
            {proyectos.map((p) => (
              <Option key={p.oid} value={p.oid}>
                {p.codigo} - {p.proyecto}
              </Option>
            ))}
          </Select>
        </Col>
        <Col xs={24} md={12} lg={8}>
          <Select
            allowClear
            showSearch
            placeholder="Departamento"
            optionFilterProp="children"
            style={{ width: "100%" }}
            value={filters.departamento}
            suffixIcon={<EnvironmentOutlined />}
            onChange={(v) => handleChange("departamento", v)}
          >
            {departamentos.map((d) => (
              <Option key={d.oid} value={d.oid}>
                {d.departamento}
              </Option>
            ))}
          </Select>
        </Col>
        <Col xs={24} md={12} lg={8}>
          <Select
            allowClear
            showSearch
            placeholder={
              filters.departamento
                ? "Municipio"
                : "Seleccione departamento primero"
            }
            disabled={!filters.departamento}
            optionFilterProp="children"
            style={{ width: "100%" }}
            value={filters.municipio}
            suffixIcon={<EnvironmentOutlined />}
            onChange={(v) => handleChange("municipio", v)}
          >
            {municipiosFiltrados.map((m) => (
              <Option key={m.oid} value={m.oid}>
                {m.municipio}
              </Option>
            ))}
          </Select>
        </Col>
        <Col xs={24} md={12} lg={6}>
          <Select
            allowClear
            placeholder="Tipo entrega"
            style={{ width: "100%" }}
            suffixIcon={<ShopOutlined />}
            value={filters.tipo_entrega}
            onChange={(v) => handleChange("tipo_entrega", v)}
          >
            <Option value={1}>Participante</Option>
            <Option value={2}>Organización</Option>
          </Select>
        </Col>
        <Col xs={24} md={12} lg={2}>
          <Space>
            <Tooltip title="Restablecer filtros">
              <Button icon={<ClearOutlined />} onClick={clearFilters} />
            </Tooltip>
            <ExportarExcelDropdown filters={filters} />
            {puedeSincronizar && (
              <Tooltip title="Sincronizar soportes">
                <Button
                  type="primary"
                  icon={<SyncOutlined />}
                  loading={loadingSync}
                  onClick={confirmSync}
                >
                </Button>
              </Tooltip>
            )}
          </Space>
        </Col>
      </Row>
    </div>
  );
}